import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import getHomeExamples from '../../api/getHomeExamples';
import { HomeExamples } from '../../globalValues';

export default function Slideshow() {

    const [images, setImages] = useState<HomeExamples[]>([]);

    async function getExamples() {
        try{
            const res: HomeExamples[] | undefined = await getHomeExamples();
            setImages(res!);
        }
        catch(e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getExamples();
    }, []);

    return (
        <div className="example-container">
            {images.map((item, i) => {
                return(
                    <div className="example-type">
                        <div className="image-container"><img src={item.thumbnail} /></div>
                        <h4>{item.id}</h4>
                        <div style={{marginLeft: '10px', marginBottom: '10px'}}>
                            <Link to="/portfolio" >
                                <button>View More</button>
                            </Link>
                        </div>                        
                    </div>
                );
            })}
        </div>
    );
}
